'use client';

import { useEffect } from 'react';

// Injects the header widget's loader.js with a ?v= cache-bust so every page load
// fetches it fresh. The id guard keeps Strict Mode's double effect from adding it twice.
export default function HeaderLoaderScript() {
  useEffect(() => {
    const SCRIPT_ID = 'angelai-header-loader';
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `${process.env.NEXT_PUBLIC_HEADER_CDN_BASE}loader.js?v=${Date.now()}`;
    document.body.appendChild(script);
  }, []);

  return null;
}
